import classNames from 'classnames'
import {Icon, type IconProps} from 'quickstart/components/content/Icon'
import {Button, type ButtonProps} from '../Button'
import S from './styles.module.scss'

interface IconButtonProps extends ButtonProps {
  icon: IconProps['icon']
  notify?: IconProps['notify']
}

export const IconButton = ({icon, notify, ...props}: IconButtonProps) => {
  return (
    <Button
      size="xs"
      variant="tertiary"
      {...props}
      className={classNames(S['icon-button'], props.className)}
    >
      <Icon icon={icon} size="100%" notify={notify} />
    </Button>
  )
}
